import { INPUT_NODE_COLOR, OUTPUT_NODE_COLOR, RESOURCE_NODE_COLOR, BUFFER_NODE_COLOR, PROCESSOR_NODE_COLOR } from '../utils/constants'
interface GetParams {
  kind: string
}

export default function Get({ kind }: GetParams) {
  switch (kind) {
    case 'input':
      return INPUT_NODE_COLOR
    case 'buffer':
      return BUFFER_NODE_COLOR
    case 'output':
      return OUTPUT_NODE_COLOR
    case 'processor':
      return PROCESSOR_NODE_COLOR
    default:
      return RESOURCE_NODE_COLOR
  }
}
